import * as api from '../../api/equityFinder/presentation';
import { makeApiActionCreatorV3 } from '../utils';

export const PRESENTATION_DOCUMENTLIST_FETCH_START =
  'PRESENTATION/PRESENTATION_DOCUMENTLIST_FETCH_START';
export const PRESENTATION_DOCUMENTLIST_FETCH_SUCCESS =
  'PRESENTATION/PRESENTATION_DOCUMENTLIST_FETCH_SUCCESS';
export const PRESENTATION_DOCUMENTLIST_FETCH_ERROR =
  'PRESENTATION/PRESENTATION_DOCUMENTLIST_FETCH_ERROR';

export const PRESENTATION_DOCUMENT_DELETE_START =
  'PRESENTATION/PRESENTATION_DOCUMENT_DELETE_START';
export const PRESENTATION_DOCUMENT_DELETE_SUCCESS =
  'PRESENTATION/PRESENTATION_DOCUMENT_DELETE_SUCCESS';
export const PRESENTATION_DOCUMENT_DELETE_ERROR =
  'PRESENTATION/PRESENTATION_DOCUMENT_DELETE_ERROR';

export const PRESENTATION_DOCUMENT_GET_START =
  'PRESENTATION/PRESENTATION_DOCUMENT_GET_START';
export const PRESENTATION_DOCUMENT_GET_SUCCESS =
  'PRESENTATION/PRESENTATION_DOCUMENT_GET_SUCCESS';
export const PRESENTATION_DOCUMENT_GET_ERROR =
  'PRESENTATION/PRESENTATION_DOCUMENT_GET_ERROR';

export const PRESENTATION_GLOBALDOCUMENTLIST_FETCH_START =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENTLIST_FETCH_START';
export const PRESENTATION_GLOBALDOCUMENTLIST_FETCH_SUCCESS =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENTLIST_FETCH_SUCCESS';
export const PRESENTATION_GLOBALDOCUMENTLIST_FETCH_ERROR =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENTLIST_FETCH_ERROR';

export const PRESENTATION_GLOBALDOCUMENT_DELETE_START =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_DELETE_START';
export const PRESENTATION_GLOBALDOCUMENT_DELETE_SUCCESS =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_DELETE_SUCCESS';
export const PRESENTATION_GLOBALDOCUMENT_DELETE_ERROR =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_DELETE_ERROR';

export const PRESENTATION_GLOBALDOCUMENT_UPLOAD_START =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_UPLOAD_START';
export const PRESENTATION_GLOBALDOCUMENT_UPLOAD_SUCCESS =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_UPLOAD_SUCCESS';
export const PRESENTATION_GLOBALDOCUMENT_UPLOAD_ERROR =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_UPLOAD_ERROR';

export const PRESENTATION_DOCUMENT_UPLOAD_START =
  'PRESENTATION/PRESENTATION_DOCUMENT_UPLOAD_START';
export const PRESENTATION_DOCUMENT_UPLOAD_SUCCESS =
  'PRESENTATION/PRESENTATION_DOCUMENT_UPLOAD_SUCCESS';
export const PRESENTATION_DOCUMENT_UPLOAD_ERROR =
  'PRESENTATION/PRESENTATION_DOCUMENT_UPLOAD_ERROR';

export const PRESENTATION_GLOBALDOCUMENT_GET_START =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_GET_START';
export const PRESENTATION_GLOBALDOCUMENT_GET_SUCCESS =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_GET_SUCCESS';
export const PRESENTATION_GLOBALDOCUMENT_GET_ERROR =
  'PRESENTATION/PRESENTATION_GLOBALDOCUMENT_GET_ERROR';

export const PRESENTATION_FETCH_START = 'PRESENTATION/PRESENTATION_FETCH_START';
export const PRESENTATION_FETCH_SUCCESS =
  'PRESENTATION/PRESENTATION_FETCH_SUCCESS';
export const PRESENTATION_FETCH_ERROR = 'PRESENTATION/PRESENTATION_FETCH_ERROR';

export const PRESENTATION_DELETE_START =
  'PRESENTATION/PRESENTATION_DELETE_START';
export const PRESENTATION_DELETE_SUCCESS =
  'PRESENTATION/PRESENTATION_DELETE_SUCCESS';
export const PRESENTATION_DELETE_ERROR =
  'PRESENTATION/PRESENTATION_DELETE_ERROR';

export const PRESENTATION_PUBLISH_START =
  'PRESENTATION/PRESENTATION_PUBLISH_START';
export const PRESENTATION_PUBLISH_SUCCESS =
  'PRESENTATION/PRESENTATION_PUBLISH_SUCCESS';
export const PRESENTATION_PUBLISH_ERROR =
  'PRESENTATION/PRESENTATION_PUBLISH_ERROR';

export const PRESENTATION_PUBLISHED_DOCUMENT_ADD_START =
  'PRESENTATION/PRESENTATION_PUBLISHED_DOCUMENT_ADD_START';
export const PRESENTATION_PUBLISHED_DOCUMENT_ADD_SUCCESS =
  'PRESENTATION/PRESENTATION_PUBLISHED_DOCUMENT_ADD_SUCCESS';
export const PRESENTATION_PUBLISHED_DOCUMENT_ADD_ERROR =
  'PRESENTATION/PRESENTATION_PUBLISHED_DOCUMENT_ADD_ERROR';

export const PRESENTATION_GLOBAL_DOCUMENT_ADD_START =
  'PRESENTATION/PRESENTATION_GLOBAL_DOCUMENT_ADD_START';
export const PRESENTATION_GLOBAL_DOCUMENT_ADD_SUCCESS =
  'PRESENTATION/PRESENTATION_GLOBAL_DOCUMENT_ADD_SUCCESS';
export const PRESENTATION_GLOBAL_DOCUMENT_ADD_ERROR =
  'PRESENTATION/PRESENTATION_GLOBAL_DOCUMENT_ADD_ERROR';

export const PRESENTATION_FINAL_PRESENTATION_FETCH_START =
  'PRESENTATION/PRESENTATION_FINAL_PRESENTATION_FETCH_START';
export const PRESENTATION_FINAL_PRESENTATION_FETCH_SUCCESS =
  'PRESENTATION/PRESENTATION_FINAL_PRESENTATION_FETCH_SUCCESS';
export const PRESENTATION_FINAL_PRESENTATION_FETCH_ERROR =
  'PRESENTATION/PRESENTATION_FINAL_PRESENTATION_FETCH_ERROR';

export const PRESENTATION_FINAL_DOCUMENT_GET_START =
  'PRESENTATION/PRESENTATION_FINAL_DOCUMENT_GET_START';
export const PRESENTATION_FINAL_DOCUMENT_GET_SUCCESS =
  'PRESENTATION/PRESENTATION_FINAL_DOCUMENT_GET_SUCCESS';
export const PRESENTATION_FINAL_DOCUMENT_GET_ERROR =
  'PRESENTATION/PRESENTATION_FINAL_DOCUMENT_GET_ERROR';

export const PRESENTATION_PREVIEW_START =
  'PRESENTATION/PRESENTATION_PREVIEW_START';
export const PRESENTATION_PREVIEW_SUCCESS =
  'PRESENTATION/PRESENTATION_PREVIEW_SUCCESS';
export const PRESENTATION_PREVIEW_ERROR =
  'PRESENTATION/PRESENTATION_PREVIEW_ERROR';

export const PRESENTATION_DRAG_ITEM = 'PRESENTATION/PRESENTATION_DRAG_ITEM';

export const PRESENTATION_ORDER_CHANGE_START =
  'PRESENTATION/PRESENTATION_ORDER_CHANGE_START';
export const PRESENTATION_ORDER_CHANGE_SUCCESS =
  'PRESENTATION/PRESENTATION_ORDER_CHANGE_SUCCESS';
export const PRESENTATION_ORDER_CHANGE_ERROR =
  'PRESENTATION/PRESENTATION_ORDER_CHANGE_ERROR';

export const PRESENTATION_TEMPLATE_FETCH_START =
  'PRESENTATION/PRESENTATION_TEMPLATE_FETCH_START';
export const PRESENTATION_TEMPLATE_FETCH_SUCCESS =
  'PRESENTATION/PRESENTATION_TEMPLATE_FETCH_SUCCESS';
export const PRESENTATION_TEMPLATE_FETCH_ERROR =
  'PRESENTATION/PRESENTATION_TEMPLATE_FETCH_ERROR';

export const PRESENTATION_TEMPLATE_CREATE_START =
  'PRESENTATION/PRESENTATION_TEMPLATE_CREATE_START';
export const PRESENTATION_TEMPLATE_CREATE_SUCCESS =
  'PRESENTATION/PRESENTATION_TEMPLATE_CREATE_SUCCESS';
export const PRESENTATION_TEMPLATE_CREATE_ERROR =
  'PRESENTATION/PRESENTATION_TEMPLATE_CREATE_ERROR';

export const PRESENTATION_CLEAR_START = 'PRESENTATION/PRESENTATION_CLEAR_START';
export const PRESENTATION_CLEAR_SUCCESS =
  'PRESENTATION/PRESENTATION_CLEAR_SUCCESS';
export const PRESENTATION_CLEAR_ERROR = 'PRESENTATION/PRESENTATION_CLEAR_ERROR';

export const PRESENTATION_DOCUMENTLIST_CLEAR_START =
  'PRESENTATION/PRESENTATION_DOCUMENTLIST_CLEAR_START';
export const PRESENTATION_DOCUMENTLIST_CLEAR_SUCCESS =
  'PRESENTATION/PRESENTATION_DOCUMENTLIST_CLEAR_SUCCESS';
export const PRESENTATION_DOCUMENTLIST_CLEAR_ERROR =
  'PRESENTATION/PRESENTATION_DOCUMENTLIST_CLEAR_ERROR';

export const fetchDocumentList = makeApiActionCreatorV3(
  api.fetchDocumentList,
  PRESENTATION_DOCUMENTLIST_FETCH_START,
  PRESENTATION_DOCUMENTLIST_FETCH_SUCCESS,
  PRESENTATION_DOCUMENTLIST_FETCH_ERROR,
);
export const fetchPresentation = makeApiActionCreatorV3(
  api.fetchPresentation,
  PRESENTATION_FETCH_START,
  PRESENTATION_FETCH_SUCCESS,
  PRESENTATION_FETCH_ERROR,
);
export const fetchGlobalDocumentList = makeApiActionCreatorV3(
  api.fetchGlobalDocumentList,
  PRESENTATION_GLOBALDOCUMENTLIST_FETCH_START,
  PRESENTATION_GLOBALDOCUMENTLIST_FETCH_SUCCESS,
  PRESENTATION_GLOBALDOCUMENTLIST_FETCH_ERROR,
);
export const deleteDocument = makeApiActionCreatorV3(
  api.deleteDocument,
  PRESENTATION_DOCUMENT_DELETE_START,
  PRESENTATION_DOCUMENT_DELETE_SUCCESS,
  PRESENTATION_DOCUMENT_DELETE_ERROR,
);
export const deleteGlobalDocument = makeApiActionCreatorV3(
  api.deleteGlobalDocument,
  PRESENTATION_GLOBALDOCUMENT_DELETE_START,
  PRESENTATION_GLOBALDOCUMENT_DELETE_SUCCESS,
  PRESENTATION_GLOBALDOCUMENT_DELETE_ERROR,
);
export const deletePresentation = makeApiActionCreatorV3(
  api.deletePresentation,
  PRESENTATION_DELETE_START,
  PRESENTATION_DELETE_SUCCESS,
  PRESENTATION_DELETE_ERROR,
);
export const getDocument = makeApiActionCreatorV3(
  api.getDocument,
  PRESENTATION_DOCUMENT_GET_START,
  PRESENTATION_DOCUMENT_GET_SUCCESS,
  PRESENTATION_DOCUMENT_GET_ERROR,
);
export const getGlobalDocument = makeApiActionCreatorV3(
  api.getGlobalDocument,
  PRESENTATION_GLOBALDOCUMENT_GET_START,
  PRESENTATION_GLOBALDOCUMENT_GET_SUCCESS,
  PRESENTATION_GLOBALDOCUMENT_GET_ERROR,
);
export const getFinalDocument = makeApiActionCreatorV3(
  api.getFinalDocument,
  PRESENTATION_FINAL_DOCUMENT_GET_START,
  PRESENTATION_FINAL_DOCUMENT_GET_SUCCESS,
  PRESENTATION_FINAL_DOCUMENT_GET_ERROR,
);
export const addPublishedDocument = makeApiActionCreatorV3(
  api.addPublishedDocument,
  PRESENTATION_PUBLISHED_DOCUMENT_ADD_START,
  PRESENTATION_PUBLISHED_DOCUMENT_ADD_SUCCESS,
  PRESENTATION_PUBLISHED_DOCUMENT_ADD_ERROR,
);
export const addGlobalDocument = makeApiActionCreatorV3(
  api.addGlobalDocument,
  PRESENTATION_GLOBAL_DOCUMENT_ADD_START,
  PRESENTATION_GLOBAL_DOCUMENT_ADD_SUCCESS,
  PRESENTATION_GLOBAL_DOCUMENT_ADD_ERROR,
);
export const uploadGlobalDocument = makeApiActionCreatorV3(
  api.uploadGlobalDocument,
  PRESENTATION_GLOBALDOCUMENT_UPLOAD_START,
  PRESENTATION_GLOBALDOCUMENT_UPLOAD_SUCCESS,
  PRESENTATION_GLOBALDOCUMENT_UPLOAD_ERROR,
);
export const uploadDocument = makeApiActionCreatorV3(
  api.uploadDocument,
  PRESENTATION_DOCUMENT_UPLOAD_START,
  PRESENTATION_DOCUMENT_UPLOAD_SUCCESS,
  PRESENTATION_DOCUMENT_UPLOAD_ERROR,
);
export const publishPresentation = makeApiActionCreatorV3(
  api.publishPresentation,
  PRESENTATION_PUBLISH_START,
  PRESENTATION_PUBLISH_SUCCESS,
  PRESENTATION_PUBLISH_ERROR,
);
export const previewPresentation = makeApiActionCreatorV3(
  api.previewPresentation,
  PRESENTATION_PREVIEW_START,
  PRESENTATION_PREVIEW_SUCCESS,
  PRESENTATION_PREVIEW_ERROR,
);
export const fetchFinalPresentation = makeApiActionCreatorV3(
  api.fetchFinalPresentation,
  PRESENTATION_FINAL_PRESENTATION_FETCH_START,
  PRESENTATION_FINAL_PRESENTATION_FETCH_SUCCESS,
  PRESENTATION_FINAL_PRESENTATION_FETCH_ERROR,
);
export const orderChange = makeApiActionCreatorV3(
  api.orderChange,
  PRESENTATION_ORDER_CHANGE_START,
  PRESENTATION_ORDER_CHANGE_SUCCESS,
  PRESENTATION_ORDER_CHANGE_ERROR,
);
export const fetchDefaultTemplate = makeApiActionCreatorV3(
  api.fetchDefaultTemplate,
  PRESENTATION_TEMPLATE_FETCH_START,
  PRESENTATION_TEMPLATE_FETCH_SUCCESS,
  PRESENTATION_TEMPLATE_FETCH_ERROR,
);
export const creatTemplates = makeApiActionCreatorV3(
  api.creatTemplates,
  PRESENTATION_TEMPLATE_CREATE_START,
  PRESENTATION_TEMPLATE_CREATE_SUCCESS,
  PRESENTATION_TEMPLATE_CREATE_ERROR,
);

export const clearDocuments = makeApiActionCreatorV3(
  api.clearDocuments,
  PRESENTATION_DOCUMENTLIST_CLEAR_START,
  PRESENTATION_DOCUMENTLIST_CLEAR_SUCCESS,
  PRESENTATION_DOCUMENTLIST_CLEAR_ERROR,
);

export const clearPresentations = makeApiActionCreatorV3(
  api.clearPresentations,
  PRESENTATION_CLEAR_START,
  PRESENTATION_CLEAR_SUCCESS,
  PRESENTATION_CLEAR_ERROR,
);

export function moveItem(dragIndex, hoverIndex) {
  return async dispatch => {
    dispatch({ type: PRESENTATION_DRAG_ITEM, data: { dragIndex, hoverIndex } });
  };
}
